import React from 'react';

export const Table = ({
  data,
  columns,
  filterConfig = [],
  buttonConfig = [],
  onRowClick = () => {},
}) => {
  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="d-flex gap-2">
          {buttonConfig.map(({ label, variant = 'primary', onClick }, index) => (
            <button key={index} className={`btn btn-${variant}`} onClick={onClick}>
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
        <div className="table-responsive full-data">
          <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
            <table className="table-responsive-sm table display dataTablesCard student-tab dataTable no-footer" id="example-student">
              <thead>
                <tr>
                  {columns.map((column, index) => (
                    <th key={index}>{column.header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.length > 0 && data?.map((item, index) => (
                  <tr key={item.id || index} className='clickable-row'>
                    {columns.map((column, colIndex) => (
                      <td 
                        key={colIndex} 
                        onClick={() => {
                          // Don't trigger row click for calendar button
                          if (column.accessor !== 'calendar') {
                            onRowClick(item);
                          }
                        }}
                      >
                        {column.render ? column.render(item) : item[column.accessor]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};